import DoorOpening from '@/services/api/door-opening';

export default {
  namespaced: true,
  state: {
    doorOpeningMobiles: [],
    barrierOpeningMobiles: [],
    DoorOpeningMobile: {},
  },
  getters: {
    doorOpeningMobiles: state => state.doorOpeningMobiles,
    barrierOpeningMobiles: state => state.barrierOpeningMobiles,
    DoorOpeningMobile: state => state.DoorOpeningMobile,
  },
  mutations: {
    setDoorOpeningMobiles: (state, payload) => {
      state.doorOpeningMobiles = payload;
    },
    setBarrierOpeningMobiles: (state, payload) => {
      state.barrierOpeningMobiles = payload;
    },
    setDoorOpeningMobile: (state, payload) => {
      state.DoorOpeningMobile = payload;
    },
  },
  actions: {
    getDoorOpeningMobiles (state, options = {}) {
      return new Promise((resolve, reject) => {
        DoorOpening.getDoorOpeningMobiles(options)
          .then(({ data }) => {
            state.commit('setDoorOpeningMobiles', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getBarrierOpeningMobiles (state, options = {}) {
      return new Promise((resolve, reject) => {
        DoorOpening.getBarrierOpeningMobiles(options)
          .then(({ data }) => {
            state.commit('setBarrierOpeningMobiles', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getDoorOpeningMobile (state, id) {
      return new Promise((resolve, reject) => {
        DoorOpening.getDoorOpeningMobile(id)
          .then((response) => {
            state.commit('setDoorOpeningMobile', response.data);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
  },
};
